/**
 * The ONE competition-session order — chronological by `startTime` (the
 * editor's "YYYY-MM-DDTHH:mm" string), sessions without a time after the
 * timed ones, the editor's `order` only as the tiebreak between those.
 *
 * Shared because two writers need it: the app (every session list, the
 * editor's save, which writes `order` from this position) and the MCP draft
 * tools (`create_competition_draft` / `update_competition_draft`, which write
 * `order` the same way). The app-side gate that no screen sorts sessions on its
 * own is apps/web/src/__tests__/sessionOrder.test.js.
 */
export function sortSessionsByStartTime(sessions) {
  return [...(sessions || [])].sort((a, b) => {
    const at = a?.startTime || "";
    const bt = b?.startTime || "";
    if (at && bt) return at.localeCompare(bt);
    if (at) return -1;
    if (bt) return 1;
    return (a?.order || 0) - (b?.order || 0);
  });
}
